import type { DatasetFile, DatasetImage } from "@/entities/dataset";
import type { ApiPayloadGet } from "@/services/api";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { client } from "@/config/client";
import { useAppNotification } from "@/modules/app-notification";
import { downloadFileWithNotify } from "@/modules/file-downloader";

import { getDatasetDownloadFileUrl } from "./dataset-download-file.helper";

export const useDatasetDownloadFile = (dataset: DatasetImage | DatasetFile) => {
  const [loading, setLoading] = useState(false);
  const { notify } = useAppNotification();
  const { t } = useTranslation();

  const downloadDatasetFile = () => {
    setLoading(true);

    // AWS S3 file links returned by api expire after 20 min. To make sure
    // the download file is still the right url, let's refetch dataset data.
    // TODO DEV-6367 improve code to avoid useless api calls when possible.
    return client.datasets
      .get(dataset.id)
      .then((response: ApiPayloadGet<DatasetImage | DatasetFile>) => {
        const dataset = response.data.data;
        const url = getDatasetDownloadFileUrl(dataset);

        if (url) downloadFileWithNotify({ url, name: dataset.name, notify });
        else notify.error({ title: t("global:downloadFailed") });
      })
      .catch(() => {
        notify.error({ title: t("global:downloadFailed") });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    loading,
    downloadFile: downloadDatasetFile,
  };
};
